export const LOAD_USERS = 'LOAD_USERS';
export const CLEAR_USERS = 'CLEAR_USERS';
export const CHANGE_USERS_LIST_OPTIONS = 'CHANGE_USERS_LIST_OPTIONS';

export const LOAD_WORKERS = 'LOAD_WORKERS';
export const CLEAR_WORKERS = 'CLEAR_WORKERS';
export const CHANGE_WORKERS_LIST_OPTIONS = 'CHANGE_WORKERS_LIST_OPTIONS';
export const LOAD_WORKER_DETAILS = 'LOAD_WORKER_DETAILS';

export const LOAD_DOMAINS = 'LOAD_DOMAINS';
export const CLEAR_DOMAINS = 'CLEAR_DOMAINS';
export const CHANGE_DOMAINS_LIST_OPTIONS = 'CHANGE_DOMAINS_LIST_OPTIONS';

export const LOAD_SCAN_DATA = 'LOAD_SCAN_DATA';
export const CLEAR_SCAN_DATA = 'CLEAR_SCAN_DATA';
export const CHANGE_SCAN_DATA_LIST_OPTIONS = 'CHANGE_SCAN_DATA_LIST_OPTIONS';

export const GET_CURR_USER = 'GET_CURR_USER';
export const LOAD_NEEDED_ACTIONS = 'LOAD_NEEDED_ACTIONS';
export const ADD_NEW_ADIVSED_ACTION = 'ADD_NEW_ADIVSED_ACTION';
export const GET_ALL_ADVISED_ACTIONS = 'GET_ALL_ADVISED_ACTIONS';
export const LOAD_ALL_TENANT_USERS = 'LOAD_ALL_TENANT_USERS';
export const ADMIN_CHANGE_USER_ROLE = 'ADMIN_CHANGE_USER_ROLE';
export const CLEAR_TENANT_USERS_LIST = 'CLEAR_TENANT_USERS_LIST';
export const ADMIN_INVITE_USERS = 'ADMIN_INVITE_USERS';
export const ADMIN_SYSTEM_SETTINGS = 'ADMIN_SYSTEM_SETTINGS';
export const GET_SYSTEM_SETTINGS = 'GET_SYSTEM_SETTINGS';
export const TOGGLE_IS_SERVICE_PROVIDER = 'TOGGLE_IS_SERVICE_PROVIDER';

export const LOAD_CUSTOMER_PROFILE_DETAILS = 'LOAD_CUSTOMER_PROFILE_DETAILS';
export const UPDATE_CUSTOMER_PROFILE = 'UPDATE_CUSTOMER_PROFILE';
export const UPDATE_COMPANY_CUSTOMER_PROFILE = 'UPDATE_COMPANY_CUSTOMER_PROFILE';
export const LOAD_COMPANY_CUSTOMER_PROFILE_DETAILS = 'LOAD_COMPANY_CUSTOMER_PROFILE_DETAILS';
export const LOAD_SERVICE_PROVIDER_WORKER_PROFILE = 'LOAD_SERVICE_PROVIDER_WORKER_PROFILE';
export const UPDATE_SERVICE_PROVIDER_WORKER_PROFILE = 'UPDATE_SERVICE_PROVIDER_WORKER_PROFILE';
export const LOAD_SERVICE_PROVIDER_COMPANY_PROFILE_DETAILS = 'LOAD_SERVICE_PROVIDER_COMPANY_PROFILE_DETAILS';
export const UPDATE_SERVICE_PROVIDER_COMPANY_PROFILE_DETAILS = 'UPDATE_SERVICE_PROVIDER_COMPANY_PROFILE_DETAILS';
export const LOAD_SERVICE_PROVIDER_FREELANCER_PROFILE = 'LOAD_SERVICE_PROVIDER_FREELANCER_PROFILE';
export const UPDATE_SERVICE_PROVIDER_FREELANCER_PROFILE = 'UPDATE_SERVICE_PROVIDER_FREELANCER_PROFILE';
export const LOAD_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS = 'LOAD_COMPANY_CUSTOMER_FULL_REGIONS_OPTIONS';
export const LOAD_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS = 'LOAD_COMPANY_CUSTOMER_FULL_INDUSTRIES_OPTIONS';
export const LOAD_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS = 'LOAD_COMPANY_CUSTOMER_FULL_REGULATIONS_OPTIONS';
export const LOAD_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS = 'LOAD_SERVICE_PROVIDER_COMPANY_FULL_SERVICES_OPTIONS';
export const LOAD_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS = 'LOAD_SERVICE_PROVIDER_COMPANY_FULL_REGIONS_OPTIONS';
export const LOAD_SERVICE_PROVIDERS_OF_COMPANY = 'LOAD_SERVICE_PROVIDERS_OF_COMPANY';
export const LOAD_CURRENT_SERVICE_PROVIDER_EMPLOYEE = 'LOAD_CURRENT_SERVICE_PROVIDER_EMPLOYEE';
export const DELETE_SERVICE_PROVIDER_EMPLOYEE_USER = 'DELETE_SERVICE_PROVIDER_EMPLOYEE_USER';
export const LOAD_CHOSEN_SERVICE_PROVIDER_EMPLOYEE_ID = 'LOAD_CHOSEN_SERVICE_PROVIDER_EMPLOYEE_ID';
export const CHANGE_SERVICE_PROVIDER_EMPLOYEE_ACTIVE_STATUS = 'CHANGE_SERVICE_PROVIDER_EMPLOYEE_ACTIVE_STATUS';
export const UPDATE_SERVICE_PROVIDER_WORKER_PROFILE_BY_ADMIN = 'UPDATE_SERVICE_PROVIDER_WORKER_PROFILE_BY_ADMIN';
export const LOAD_SERVICE_PROVIDER_EMPLOYEE_BEFORE_EDIT = 'LOAD_SERVICE_PROVIDER_EMPLOYEE_BEFORE_EDIT';
export const VALIDATE_TLD = 'VALIDATE_TLD';
export const UPDATE_SENSITIVITY = 'UPDATE_SENSITIVITY';
export const UPDATE_DOMAIN_SCAN_SETTINGS = 'UPDATE_DOMAIN_SCAN_SETTINGS';
export const DELETE_USER = 'DELETE_USER';
export const DELETE_PENDING_USER = 'DELETE_PENDING_USER';
export const DISABLE_DELETE_USER_BUTTON = 'DISABLE_DELETE_USER_BUTTON';
export const SET_USER_DETAILS_FOR_EDIT = 'SET_USER_DETAILS_FOR_EDIT';
export const CLEAR_USER_DETAILS_FOR_EDIT = 'CLEAR_USER_DETAILS_FOR_EDIT';
export const CHANGE_USER_DETAILS_FOR_EDIT = 'SET_USER_DETAILS_FOR_EDIT';
export const CLEAR_CHANGE_USER_DETAILS_FOR_EDIT = 'CLEAR_USER_DETAILS_FOR_EDIT';
export const SAVE_USER = 'SAVE_USER';
export const RESET_USER_PASSWORD = 'RESET_USER_PASSWORD';
export const CLEAR_RESET_USER_PASSWORD = 'CLEAR_RESET_USER_PASSWORD';
export const LOAD_LICENSING = 'LOAD_LICENSING';
